import { Suspense } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/cn'

const tabs = [
  { to: '/admin/settings/geofencing', label: 'Obszar placówki' },
  { to: '/admin/settings/positions', label: 'Stanowiska' },
  { to: '/admin/settings/notifications', label: 'Powiadomienia push' },
]

export default function SettingsLayout() {
  return (
    <div className="space-y-6">
      <div className="border-b border-border-subtle">
        <nav className="flex gap-1 -mb-px overflow-x-auto">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                cn(
                  'px-4 py-3 text-sm font-medium border-b-2 transition whitespace-nowrap',
                  isActive
                    ? 'border-brand-accent text-text-primary'
                    : 'border-transparent text-text-muted hover:text-text-primary',
                )
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      {/* Własna granica, bo ta w AdminLayout stoi NAD tym komponentem —
          przy pierwszym wejściu w geofencing (chunk maplibre) gasiłaby razem
          z panelem także pasek zakładek ustawień. Tutaj miga tylko treść. */}
      <Suspense
        fallback={
          <p className="text-sm text-text-muted inline-flex items-center gap-2">
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
            Wczytywanie…
          </p>
        }
      >
        <Outlet />
      </Suspense>
    </div>
  )
}
